const HTTP_PROTOCOLS = ['http:', 'https:'];

/**
 * Whether a URL protocol (as in `URL#protocol`, e.g. "https:") is http or https.
 * @param {string} protocol
 * @returns {boolean}
 */
export default function isHttpProtocol(protocol) {
  return HTTP_PROTOCOLS.includes(protocol);
}
